import React from 'react'
import { List } from 'antd'
import { useTranslation } from 'next-i18next'
import { UserSubscription } from 'src/core/models'
import { CustomTag, CustomText } from 'src/components'
import { getTransformedDate } from 'src/core/helpers'

const UserSubscriptionList: React.FC<{ subscriptions: UserSubscription[]}> = ({ subscriptions }) => {
  const { t } = useTranslation()

  const getTagProps = (item: UserSubscription) => {
    return {
      active: { text: t('Subscription.Active'), type: 'success' },
      inactive: { text: t('Subscription.Inactive'), type: 'warning' },
    }[item.is_active ? 'active' : 'inactive']
  }

  const getProductLabel = (item: UserSubscription) => {
    return {
      'prime calculator': t('Subscription.PremiumCalculator'),
      'api-business-plan': t('Subscription.ApiPro'),
      'api-enterprise-plan': t('Subscription.PremiumApi')
    }[item.subscribed_product]
  }

  const getProductDateLabel = (item: UserSubscription) => {
    const dateParams = {
      dateStart: getTransformedDate(item.date_start),
      dateEnd: getTransformedDate(item.date_end),
    }
    return t('Subscription.DateRange', dateParams)
  }

  return (
    <List
      itemLayout='horizontal'
      dataSource={subscriptions}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            title={<CustomText label={getProductLabel(item)} strong />}
            description={getProductDateLabel(item)}
          />
          <CustomTag {...getTagProps(item)} />
        </List.Item>
      )}
    />
  )
}

export default UserSubscriptionList
